import { LampEasySearchJsEnv } from "./lamp_js_env";

export class LampEasySearch {
  constructor(private model: LampEasySearchJsEnv) {
    this.model = { ...model };
  }

  getModel(): LampEasySearchJsEnv {
    return {
      ...this.model
    };
  }

  update(model: LampEasySearchJsEnv) {
    this.model = model
  }

  updateSelectedModel(selectedModel: string) {
    this.model.selectedModel = selectedModel;
  }

  updateInputWord(inputWord: string) {
    this.model.inputWord = inputWord;
  }
}